import EditRegisterData from './EditRegisterData';
export default EditRegisterData;